import { ErrorMessages } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const dragAndDropLight = ({ coreApi, props }: BehaviorParameters) => {
  const productId = props.coreProductIds ? props.coreProductIds[0] : props.coreProductId;
  const placementResult = coreApi.products.add(productId, props.position);

  if (!placementResult.valid && placementResult.errors && placementResult.errors.length > 0) {
    const placementAttemptErrorMessage = !hideNoFramesInSceneErrorMessage(coreApi)
      ? ErrorMessages.NoFramesInScene
      : placementResult?.errors?.find(e => (e as any).collisions?.length > 0)
      ? ErrorMessages.ItemWontFit
      : null;
    if (placementAttemptErrorMessage) {
      coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
    }
    coreApi.entities.disposeCollidingEntities(placementResult.errors);
  }
  return placementResult;
};

export default dragAndDropLight;
